<template>
  <svg width="25" height="25" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0V0ZM1.6 3.2H6.4V4.8H1.6V3.2Z"
      fill="#EC1B0E"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconAccessNo',
}
</script>

<style scoped></style>
